// extracted by mini-css-extract-plugin
export default {"item":"sideMenu_item__fM+yy","avatar":"sideMenu_avatar__mZJkG","name":"sideMenu_name__Zg8-J","active":"sideMenu_active__mEk0z"};